export default "__VITE_ASSET__211828f0__"